export function mapPaymentStatus(status) {
  const key = String(status || '').toLowerCase()
  const map = {
    paid: '已付款',
    unpaid: '未付款',
    refunded: '已退款',
  }
  return map[key] || (status || '-')
}

export function mapPaymentMethod(method) {
  const key = String(method || '')
    .replace(/[\s_-]/g, '')
    .toLowerCase()
  const map = {
    cash: '現金',
    vacc: '虛擬帳戶',
    storecredit: '到店信用卡',
    free: '免費',
    prepaid: '預付方案折抵',
    atm: '線下匯款',
    credit: '信用卡',
    creditcard: '信用卡',
    deposit: '儲值金抵扣',
  }
  return map[key] || (method || '-')
}

export function buildPaymentInfoDisplay(payment, fallback = {}) {
  if (!payment) return fallback
  const detail = payment.detail || {}
  const methodRaw = detail.type || payment.paymentMethod || ''
  const statusRaw = payment.paymentStatus || payment.status || ''
  return {
    method: mapPaymentMethod(methodRaw),
    status: mapPaymentStatus(statusRaw),
    time: payment.paidAt || detail.tradeDate || '-',
  }
}

export function buildInvoiceInfoDisplay(invoice, displayId, fallback = {}) {
  if (!invoice) return fallback
  return {
    orderId: displayId || '-',
    invoiceDate: invoice.createTime || '-',
    invoiceNumber: invoice.invoiceNumber || '-',
    randomCode: invoice.randomNum || '-',
    invoiceType: invoice.taxType || '-',
    carrierType: invoice.carrierType || '-',
  }
}
